"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldDef = exports.FieldDefMap = void 0;
const tslib_1 = require("tslib");
require("babel-polyfill");
const Utilities_1 = require("../javascript/Utilities");
const Base_1 = require("./Base");
class FieldDefMap {
}
exports.FieldDefMap = FieldDefMap;
;
class FieldDef {
    constructor(name, type, multiValue = false, ftKeyField = undefined, ftFields = undefined, parentFTKeyField = undefined, childFTKeyFields = undefined) {
        this._multiValue = false;
        this._ftKeyField = undefined;
        this._ftFields = undefined;
        this._parentFTKeyField = undefined;
        this._childFTKeyFields = undefined;
        if (name)
            this._name = name;
        else
            this._name = "";
        if (type)
            this._type = type;
        else
            this._type = Base_1.FieldType.Undef;
        if (multiValue)
            this._multiValue = multiValue;
        else
            this._multiValue = false;
        if (ftKeyField)
            this._ftKeyField = ftKeyField;
        if (ftFields)
            this._ftFields = ftFields;
        if (parentFTKeyField)
            this._parentFTKeyField = parentFTKeyField;
        if (childFTKeyFields)
            this._childFTKeyFields = childFTKeyFields;
    }
    // Properties
    get name() {
        return this._name;
    }
    ;
    get type() {
        return this._type;
    }
    ;
    get multiValue() {
        return this._multiValue;
    }
    ;
    get ftKeyField() {
        return this._ftKeyField;
    }
    ;
    get ftFields() {
        return this._ftFields;
    }
    ;
    get parentFTKeyField() {
        return this._parentFTKeyField;
    }
    ;
    get childFTKeyFields() {
        return this._childFTKeyFields;
    }
    ;
    get isFTField() {
        return (this._ftKeyField != undefined);
    }
    get isFTKeyField() {
        return (this._ftFields != undefined);
    }
    get otherFTFields() {
        let fieldDefReturn = [];
        if ((this._ftKeyField) && (this._ftKeyField._ftFields)) {
            for (let ftField of this._ftKeyField._ftFields) {
                if (ftField._name !== this._name) {
                    fieldDefReturn.push(ftField);
                }
            }
        }
        return fieldDefReturn;
    }
    // Methods
    /**
     * Retrieves the FieldDefs for a category
     * @param catId
     * @param virtualFields : default=undefined. In new applications virtualFields must NOT be used!!
     *  Virtual Fields are Fields which do not physically exist. They are fields which are used to transfer some special data from the server to the client.
     *  If virtualFields!=undefined the getFieldDefsForCatId will NOT use a cache!
     */
    static getFieldDefsForCatId(catId, virtualFields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let fieldDefMap = FieldDef._mapFieldDefs[catId];
            let fetchNecessary = ((!fieldDefMap) || (virtualFields != undefined));
            if (fetchNecessary) {
                let requestData = {
                    catIds: [catId],
                    virtualFields
                };
                let urlName = Utilities_1.synUtil.getWSUrl("GetFieldDefs");
                try {
                    let fieldDefsRaw = yield Utilities_1.synUtil.getAJAXDataAsync({
                        method: "POST",
                        url: urlName,
                        requestData: JSON.stringify(requestData)
                    });
                    let ftKeyFieldsToFTFieldNames = [];
                    let ftKeyFieldsToChildFTKeyFieldNames = [];
                    fieldDefMap = new FieldDefMap();
                    let fieldDefsRawForCat = fieldDefsRaw[catId];
                    for (let xField = 0; xField < fieldDefsRawForCat.length; xField++) {
                        let fieldRaw = fieldDefsRawForCat[xField];
                        let fieldDefType = Base_1.FieldType.String;
                        let isMultiValue = false;
                        let ftKeyField;
                        let parentftKeyField;
                        if (fieldRaw.Value) {
                            if (fieldRaw.Value.type)
                                fieldDefType = Base_1.FieldType[fieldRaw.Value.type];
                            if (fieldRaw.Value.multiValue)
                                isMultiValue = fieldRaw.Value.multiValue;
                            if (fieldRaw.Value.ftkeyFieldName) {
                                ftKeyField = fieldDefMap[fieldRaw.Value.ftkeyFieldName];
                                if (!ftKeyField)
                                    // Das FTKey-Field müsste bereits geladen sein!
                                    throw new Error("FTKey-Field with name " + fieldRaw.Value.ftkeyFieldName + " was not found!");
                            }
                            if (fieldRaw.Value.parentftkeyFieldName) {
                                parentftKeyField = fieldDefMap[fieldRaw.Value.parentftkeyFieldName];
                                if (!parentftKeyField)
                                    // Das Parent-FTKey-Field müsste bereits geladen sein!
                                    throw new Error("Parent-FTKey-Field with name " + fieldRaw.Value.parentftkeyFieldName + " was not found!");
                            }
                        }
                        let fieldDef = new FieldDef(fieldRaw.Key, fieldDefType, isMultiValue, ftKeyField, undefined, parentftKeyField, undefined);
                        fieldDefMap[fieldRaw.Key] = fieldDef;
                        // Jetzt noch etwaige Verweise "sammeln", die später verlinkt werden müssen
                        if (fieldRaw.Value) {
                            if (fieldRaw.Value.ftFieldNames) {
                                ftKeyFieldsToFTFieldNames.push([fieldDef, fieldRaw.Value.ftFieldNames]);
                            }
                            if (fieldRaw.Value.childftkeyFieldNames) {
                                ftKeyFieldsToChildFTKeyFieldNames.push([fieldDef, fieldRaw.Value.childftkeyFieldNames]);
                            }
                        }
                    }
                    // Bei den FTKey-Fields noch die Links zu deren FT-Fields eintragen
                    for (let xField = 0; xField < ftKeyFieldsToFTFieldNames.length; xField++) {
                        let ftKeyFieldToFTFieldNames = ftKeyFieldsToFTFieldNames[xField];
                        let ftKeyField = ftKeyFieldToFTFieldNames[0];
                        let ftFieldNames = ftKeyFieldToFTFieldNames[1];
                        ftKeyField._ftFields = [];
                        for (let xFTField = 0; xFTField < ftFieldNames.length; xFTField++) {
                            let ftFieldName = ftFieldNames[xFTField];
                            let ftField = fieldDefMap[ftFieldName];
                            if (!ftField)
                                throw new Error("FT-Field with name " + ftFieldName + " was not found!");
                            ftKeyField._ftFields.push(ftField);
                        }
                    }
                    // Bei den FTKey-Fields noch die Links zu deren Child-FTKey-Fields eintragen
                    for (let xField = 0; xField < ftKeyFieldsToChildFTKeyFieldNames.length; xField++) {
                        let ftKeyFieldToChildFTFieldNames = ftKeyFieldsToChildFTKeyFieldNames[xField];
                        let ftKeyField = ftKeyFieldToChildFTFieldNames[0];
                        let ftChildFTKeyFieldNames = ftKeyFieldToChildFTFieldNames[1];
                        ftKeyField._childFTKeyFields = [];
                        for (let xChildFTKeyField = 0; xChildFTKeyField < ftChildFTKeyFieldNames.length; xChildFTKeyField++) {
                            let childftkeyFieldName = ftChildFTKeyFieldNames[xChildFTKeyField];
                            let childftkeyField = fieldDefMap[childftkeyFieldName];
                            if (!childftkeyField)
                                throw new Error("Child-FTKey-Field with name " + childftkeyFieldName + " was not found!");
                            ftKeyField._childFTKeyFields.push(childftkeyField);
                        }
                    }
                    // Das folgende Feld wird vom Server nicht zurückgegeben und ist kein STRINGVALUE --> hier für jede Kategorie manuell einfügen, weil es ein Number-Value ist und damit die dafür verwendete Default-String-FieldDef nicht korrekt wäre!
                    fieldDefMap["cgdocstructure.structuretype"] = new FieldDef("cgdocstructure.structuretype", Base_1.FieldType.Digit);
                    if (!virtualFields)
                        // if virtual fields are required the FieldDef objects will NOT be cached (keep the cache tidy!)
                        FieldDef._mapFieldDefs[catId] = fieldDefMap;
                }
                catch (ex) {
                    Utilities_1.synUtil.getAJAXDataFail(ex, undefined, undefined, urlName);
                    return Promise.reject(ex);
                }
            }
            return fieldDefMap;
        });
    }
    // Helper
    static NewStringFieldDef(name) {
        return new FieldDef(name, Base_1.FieldType.String);
    }
    static NewDigitFieldDef(name) {
        return new FieldDef(name, Base_1.FieldType.Digit);
    }
    static NewDateTimeFieldDef(name) {
        return new FieldDef(name, Base_1.FieldType.DateTime);
    }
    static NewBoolFieldDef(name) {
        return new FieldDef(name, Base_1.FieldType.Bool);
    }
    static NewMultiValueStringFieldDef(name) {
        return new FieldDef(name, Base_1.FieldType.String, true);
    }
    static NewMultiValueDigitFieldDef(name) {
        return new FieldDef(name, Base_1.FieldType.Digit, true);
    }
    static NewMultiValueDateTimeFieldDef(name) {
        return new FieldDef(name, Base_1.FieldType.DateTime, true);
    }
    static NewMultiValueBoolFieldDef(name) {
        return new FieldDef(name, Base_1.FieldType.Bool, true);
    }
}
exports.FieldDef = FieldDef;
FieldDef._mapFieldDefs = {};
FieldDef.idFieldDef = FieldDef.NewStringFieldDef("id");
FieldDef.nameFieldDef = FieldDef.NewStringFieldDef("name");
FieldDef.treenameFieldDef = FieldDef.NewStringFieldDef("treename");
FieldDef.iconFieldDef = FieldDef.NewStringFieldDef("icon");
FieldDef.commentFieldDef = FieldDef.NewStringFieldDef("id");
FieldDef.nonameStringFieldDef = FieldDef.NewStringFieldDef("");
;
